import React from 'react';
import {useImportTableContext} from "v4/pages/admin/Import/contexts/ImportTableContext";
import FieldWrapper from "v4/components/form/FieldWrapper/FieldWrapper";
import {FormProvider} from "react-hook-form";

export default function ValidateImportFormFilters({searchFormData, methods}) {
    const {getSortableFieldName} = useImportTableContext();

    const formResults = searchFormData['hydra:member']?.results ?? {};

    if (!Object.keys(formResults).length) return null;

    const rowsStatusFieldName = getSortableFieldName('rowsStatus');
    const rowsSqlOperationFieldName = getSortableFieldName('rowsSqlOperation');

    return (
        <FormProvider {...methods}>
            <div className="import-table__infos-filters__filters">
                <FieldWrapper name={rowsStatusFieldName}
                              field={formResults[rowsStatusFieldName]}
                              isLabelActive={true}
                />
                <FieldWrapper name={rowsSqlOperationFieldName}
                              field={formResults[rowsSqlOperationFieldName]}
                              isLabelActive={true}
                />
            </div>
        </FormProvider>
    )
}
